import React from 'react';

import { shouldShowRefreshedFilterRow } from '../../../../../common/utils/experiments';
import { usePrimaryProduct } from '../../../../../controllers/store/bootstrap';
import { FiltersDropdown } from './dropdown';

export const FiltersControl = (): React.JSX.Element | null => {
	const [primaryProduct] = usePrimaryProduct();

	if (!shouldShowRefreshedFilterRow(primaryProduct)) {
		return null;
	}

	return <FiltersDropdown />;
};
